import React from 'react'
import LanguageSwitcher from '../common/languageSwitcher'
import { Logo } from '../common/logo'
import './wrapper.sass'

export function Wrapper({ children }) {
  return (
    <div className="wrapper">
      <div className="wrapper-container">
        <div className="wrapper-languages">
          <LanguageSwitcher />
        </div>
        <div className="wrapper-header">
          <Logo />
        </div>
        <div className="wrapper-content">{children}</div>
      </div>
    </div>
  )
}
